@if (isLoaderVisible) {
    <div class="loaderWrap">
        <div class="loader"></div>
    </div>
}
<router-outlet></router-outlet>
<app-clear-cart-info></app-clear-cart-info>

<app-custom-toaster></app-custom-toaster>
